import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1712.000000, -667.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1712.000000, 667.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "inherit",
  x: "0",
  y: "5",
  width: "29",
  height: "20",
  rx: "3"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#fff",
  cx: "6",
  cy: "9",
  r: "2"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#fff",
  cx: "18.5",
  cy: "14.5",
  r: "6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12,0 L17,0 C18.6568542,-3.04359188e-16 20,1.34314575 20,3 L20,3 L20,3 L9,3 C9,1.34314575 10.3431458,3.04359188e-16 12,0 Z",
  fill: "inherit"
})))), 'Camera', {
  viewBox: '0 0 29 25'
});